import {Link} from "react-router-dom";
import Weather from "../../components/shared/Weather";
import Loader from "../../components/shared/Loader";
import InterventionItem from "../../components/offer/interventionItem";
import {useDailyIntervention} from "../../../hooks/useInterventions";
import {simpleDate} from "../../../utils/date";
import {interventionStatus} from "../../../utils/constants";
import imagePub from "../../../images/ImagePub.jpg";
import arrow from "../../../images/arrowIntervention.png";
import CountCard from "./CountCard";
import InterventionStats from "./InterventionStats";
import ReviewStats from "./reviewStats";
import RevenueCard from "./RevenueCard";
import {useStats} from "../../../hooks/useStats";
import {useState} from "react";
import PubList from "../../components/shared/PubList";
import {useReducer} from "react";

const DashboardPage = () => {
  const today = new Date();

  const {interventions, isError, isLoading} = useDailyIntervention({
    size: 5,
    filter: {
      startDate: simpleDate(today),
      status: [
        interventionStatus.NEW,
        interventionStatus.PROCESSING,
        interventionStatus.REPORTED,
      ],
    },
    order: [["startDate", "ASC"]],
  });
  const [interventionDateLabel, setInterventionDateLabel] =
    useState("Toute la période");
  const [ReviewDateLabel, setReviewDateLabel] = useState("Toute la période");
  const [RevenueDateLabel, setRevenueDateLabel] = useState("Cette Année");
  const fromDate = ""; /* formatDate(aujourdhui, "YYYY-MM-DD"); */
  const toDate = ""; /* formatDate(
      aujourdhui.setDate(aujourdhui.getDate() + 1),
      "YYYY-MM-DD"
    ); */

  const initialFilterState = {
    interventionDate: {
      from: fromDate,
      to: toDate,
    },
    reviewDate: {
      from: fromDate,
      to: toDate,
    },
    year: new Date().getFullYear(),
    month: {
      from: "",
      to: "",
    },
  };

  const filterReducer = (state, action) => {
    switch (action.type) {
      case "Nombre d'interventions":
        return {
          ...state,
          interventionDate: {
            from: action.payload.from,
            to: action.payload.to,
          },
        };
      case "Nombre de reviews":
        return {
          ...state,
          reviewDate: {
            from: action.payload.from,
            to: action.payload.to,
          },
        };
      case "Revenue":
        const filter = {
          ...state,
        };
        if (action.payload?.year) {
          filter.year = action.payload?.year;
          delete filter.month;
        } else {
          filter.month = {
            from: action.payload?.from ?? "",
            to: action.payload?.to ?? "",
          };
          delete filter.year;
        }
        return filter;
      case "RESET_FILTER":
        return initialFilterState; // Resets to the initial state
      default:
        return state;
    }
  };

  const [filter, dispatch] = useReducer(filterReducer, initialFilterState);

  const {
    data,

    isLoading: isStatsLoading,
    isError: isStatsError,
    optionList,
  } = useStats({dispatch, filter});
  if (isStatsError || isError) {
    return "Pas de données.";
  }
  if (isStatsLoading || isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="w-full lg:grid lg:grid-cols-4 gap-6 !px-2 lg:!px-0 pb-4 ">
        <div className="col-span-3 w-full flex flex-col gap-6 justify-start items-start">
          <div className="text-2xl font-semibold text-[#19295C]">
            Tableau de bord
          </div>
          <div className="grid grid-cols-3 gap-x-6 gap-y-6 w-full">
            <CountCard
              icon={<i className="fi fi-rr-bank flex items-center"></i>}
              label={"Chiffre d’affaires"}
              value={data?.turnover ?? 0}
              orange={true}
              currency={"€"}
            />
            <CountCard
              icon={
                <i className="fi fi-rr-calculator-money flex items-center"></i>
              }
              label={"Solde en cours"}
              value={data?.currentBalance ?? data?.sold ?? 0}
              currency={"€"}
            />
            <CountCard
              icon={
                <i className="fi fi-rr-rectangle-list flex items-center"></i>
              }
              label={"Nbr d’interventions"}
              value={data?.allInterventions ?? 0}
            />
          </div>
          <div className="grid grid-cols-2 w-full gap-x-6 gap-y-6 ">
            <InterventionStats
              dateLabel={interventionDateLabel}
              setDateLabel={setInterventionDateLabel}
              stats={data?.interventions}
              optionsList={optionList}
              dispatch={dispatch}
              filter={filter}
            />
            <ReviewStats
              stats={data?.reviews}
              optionsList={optionList}
              dateLabel={ReviewDateLabel}
              setDateLabel={setReviewDateLabel}
              dispatch={dispatch}
              filter={filter}
            />
          </div>
          <div className="w-full">
            <RevenueCard
              stats={data?.turnoverStats}
              // dispatch={dispatch}
              optionsList={optionList}
              dateLabel={RevenueDateLabel}
              setDateLabel={setRevenueDateLabel}
            />
          </div>
        </div>
        <div className="w-full hidden  h-fit    pb-4  lg:flex flex-col gap-4 self-start  ">
          <Weather />
          <div className="w-full rounded-2xl  bg-white flex flex-col text-[#19295C] font-bold text-xl ">
            <div className="w-full flex items-start justify-between p-3">
              <span className="font-semibold text-lg">
                Interventions à venir
              </span>
              <Link to={"/interventions"}>
                <img src={arrow} className="cursor-pointer" alt="" />
              </Link>
            </div>
            {isLoading && <Loader />}
            {isError && (
              <div className="p-4 text-red text-center text-xs">
                "Oups ! Un problème est survenu lors de la récupération des
                données. Veuillez vérifier votre connexion ou réessayer plus
                tard."
              </div>
            )}
            {interventions && !!interventions.length ? (
              interventions.map((intervention) => (
                <InterventionItem
                  key={intervention.id}
                  intervention={intervention}
                  className={"border-b border-solid border-[#D6E2EF] "}
                />
              ))
            ) : (
              <div className="text-center py-3 font-medium text-base text-[#7e7e7e]">
                Pas d'interventions.
              </div>
            )}
          </div>

          <PubList />
        </div>
      </div>
    </>
  );
};

export default DashboardPage;
